class Layout {
    name: string;
    tab: string;
    required: number;
    hidden: number;
    sensitive: boolean;
    fields: any[];
    sequence: number;
    readonly: boolean;

    constructor() {
        this.name = "";
        this.tab = "";
        this.required = 1;
        this.hidden = 0;
        this.sensitive = false;
        this.fields = [];
        this.sequence = 0;
        this.readonly = false;
    }
}

export default Layout;